import styled from "styled-components";
import { Link } from "next-view-transitions";

import STYLES from "@vita-learning/styles";
import { Icon } from "../widgets";

export const Container = styled.div<{ $toolbar: boolean }>`
	display: grid;
	flex: 1;
	position: relative;
	height: 100%;
	width: 100%;
	
	${({ $toolbar }) =>
		$toolbar
			? `
		border: 1px solid ${STYLES.colors.lights.borders.light};
		grid-area: editor;
		grid-template-rows: minmax(75px, auto) minmax(0, 1fr) auto;
	`
			: `
		grid-template-rows: minmax(0, 1fr) auto;
	`}
`;

export const Footer = styled.div`
	align-items: center;
	background-color: #FFF;
	display: inline-flex;
	flex-direction: row-reverse;
	height: 2rem;
	padding: 0.25rem 1rem;
	z-index: 2;
	
	small {
		color: ${STYLES.colors.lights.texts.subtle};
		font-size: 0.75rem;
		font-style: italic;

		@media screen and (min-width: 576px){
			font-size: 0.875rem;
		}
	}
`;

export const StyledToolbar = styled.div`
	align-items: center;
	border-bottom: 1px solid ${STYLES.colors.lights.borders.light};
	display: flex;
	justify-content: space-between;
	height: 100%;
	overflow-x: auto;
	margin: 0;
	padding: 0.25rem;
	padding-right: 1rem;

	svg {
		height: 1.125rem;
		width: 1.125rem;
	}
`;

export const StyledButtonContainer = styled.div`
	align-items: center;
	border-right: 1px solid ${STYLES.colors.lights.borders.light};
	display: flex;
	justify-content: space-between;
	margin: 0;

	&&& {
		color: ${STYLES.colors.lights.icons.normal};
	
		&:hover,
		&:focus,
		&:active {
			color: ${STYLES.colors.lights.icons.interaction};
		}
	}
`;

export const StyledIcon = styled(Icon)`
	&&& {
		color: ${STYLES.colors.lights.icons.normal};
	
		&:hover,
		&:focus,
		&:active {
			color: ${STYLES.colors.lights.icons.interaction};
		}
	}
`;

/**
 * @deprecated
 */
export const StyledToolbarGroup = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	height: 100%;
	margin-left: 0.5rem;
	padding: 0;
`;

/**
 * @deprecated
 */
export const StyledLink = styled(Link)<{ $disabled: boolean }>`
  background-color: transparent;
	border: none;
	cursor: pointer;
	outline: none;
	margin-right: 0.5rem;
	padding: 0.25rem 0.5rem;

	${({ $disabled }) => {
		if ($disabled)
			return `
				cursor: not-allowed;
				pointer-events: none;
			`;
	}}

	&&& {
		svg {
			color: ${STYLES.colors.lights.icons.normal};
			opacity: ${({ $disabled }) => ($disabled ? 0.75 : 1)};
			
			&:hover,
			&:active,
			&:focus {
				color: ${({ $disabled }) => ($disabled ? STYLES.colors.lights.icons.normal : STYLES.colors.vitas.primary)};
			}	
		}
	}
`;

export const StyledButton = styled.button<{ $pressed?: boolean }>`
	background-color: transparent;
	border: none;
	cursor: pointer;
	outline: none;
	padding: 0.25rem 0.5rem;

	&:disabled {
		cursor: not-allowed;
		pointer-events: none;
	}

	&&& {
		svg {
			color: ${({ $pressed }) => ($pressed ? STYLES.colors.vitas.primary : STYLES.colors.lights.icons.normal)};
			
			&:hover,
			&:active,
			&:focus {
				color: ${({ $pressed }) => ($pressed ? STYLES.colors.vitas.secondary : STYLES.colors.lights.icons.normal)};
			}	
			
			&:disabled {
				color: ${STYLES.colors.lights.icons.normal};
			}
		}
	}
`;
